import EDC from '../../../components/games/shared/globals';

/**
 *
 */
EDC.Animations.IntroGmg = function (scene) {
  this.scene = scene;
  this.onCompleteCallback = null;
  this.logo = null;
  this.flickerData = [{ startAlpha: 0, targetAlpha: 1, duration: 1500 },
    /* {startAlpha: 0, targetAlpha: 1, duration: 100},
        {startAlpha: 1, targetAlpha: 1, duration: 2000},
        {startAlpha: 1, targetAlpha: 0, duration: 100},
        {startAlpha: 0, targetAlpha: 1, duration: 100},
        {startAlpha: 1, targetAlpha: 1, duration: 500},
        {startAlpha: 1, targetAlpha: 0, duration: 100},
        {startAlpha: 0, targetAlpha: 1, duration: 100},
        {startAlpha: 1, targetAlpha: 1, duration: 500},
        {startAlpha: 0, targetAlpha: 1, duration: 100},
        {startAlpha: 1, targetAlpha: 0, duration: 100},
        {startAlpha: 0, targetAlpha: 1, duration: 100},
        {startAlpha: 1, targetAlpha: 0, duration: 100},
        {startAlpha: 1, targetAlpha: 0, duration: 100},
        {startAlpha: 0, targetAlpha: 1, duration: 3000}, */
  ];
  this.flickerIndex = 0;
  return this;
};
/**
 *
 */
EDC.Animations.IntroGmg.prototype.create = function (onCompleteCallbackParam) {
  this.onCompleteCallback = onCompleteCallbackParam;

  // eslint-disable-next-line vars-on-top
  const gameWidth = this.scene.game.config.width;
  const gameHeight = this.scene.game.config.height;

  this.logo = this.scene.add.sprite(gameWidth / 2, gameHeight / 2, 'logo');

  return this;
};
/**
 *
 */
EDC.Animations.IntroGmg.prototype.flicker = function () {
  if (this.flickerIndex >= this.flickerData.length) {
    if (this.onCompleteCallback) {
      this.onCompleteCallback();
    }
  } else {
    const data = this.flickerData[this.flickerIndex];
    this.logo.setAlpha(data.startAlpha);
    this.scene.tweens.add({
      targets: this.logo,
      alpha: data.targetAlpha,
      duration: data.duration,
      delay: data.delay ? data.delay : 0,
      ease: 'Linear',
      onComplete: function () {
        // eslint-disable-next-line no-plusplus
        this.flickerIndex++;
        this.flicker();
      }.bind(this),
    });
  }
};
/**
 *
 */
EDC.Animations.IntroGmg.prototype.start = function () {
  this.flicker();
};
/**
 *
 */
EDC.Animations.IntroGmg.prototype.getImage = function () {
  return this.logo;
};


export default EDC.Animations.IntroGmg;
